var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AccordionCore, } from '@core-front/accordion';
import { ThemeContext, } from '@telia-front/theme-provider';
export const AccordionContext = React.createContext({
    hideHeaderOnOpen: false,
    isMobile: false,
});
export default class Accordion extends React.Component {
    constructor(props) {
        super(props);
        this.handleResize = () => {
            const isMobile = window.matchMedia(`(max-width: ${this.context.breakPoints.lg - 1}px)`).matches;
            if (this.state.isMobile !== isMobile) {
                this.setState({
                    isMobile,
                });
            }
        };
        this.state = {
            isMobile: false,
        };
    }
    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    BEM() {
        const classArray = [];
        if (this.props.theme) {
            classArray.push('accordion--theme-' + this.props.theme);
        }
        if (this.props.hideHeaderOnOpen) {
            classArray.push('accordion--hide-header');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        const _a = this.props, { hideHeaderOnOpen } = _a, rest = __rest(_a, ["hideHeaderOnOpen"]);
        const accordionContextValue = {
            hideHeaderOnOpen: !!this.props.hideHeaderOnOpen,
            isMobile: this.state.isMobile,
        };
        return (React.createElement(AccordionContext.Provider, { value: accordionContextValue },
            React.createElement(AccordionCore, Object.assign({}, rest, { className: this.BEM() }))));
    }
}
Accordion.contextType = ThemeContext;
